module.exports = __webpack_public_path__ + "static/img/node_color.a410d63.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/about/tutorial/img/node_color.png
// module id = vI4B
// module chunks = 1